import React from 'react'
import { Script } from "gatsby"

const Scripts = () => {
  return (
    <>
      {/* ONETRUST - needs to be at top, before all other scripts */}
      <Script
        id="OneTrust"
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        charset="UTF-8"
        data-domain-script="019f629a-c99c-77e2-949b-1a6fb2474025"
      />
      <Script id="OneTrustWrapper">
        {`
          function OptanonWrapper() {
            if (!document.getElementById('ot-otto-overrides')) {
              var s = document.createElement('style');
              s.id = 'ot-otto-overrides';
              s.textContent = [
                '#onetrust-consent-sdk #onetrust-banner-sdk,',
                '#onetrust-consent-sdk #onetrust-pc-sdk,',
                '#onetrust-consent-sdk #onetrust-banner-sdk .ot-sdk-container,',
                '#onetrust-consent-sdk #onetrust-pc-sdk .ot-sdk-container,',
                '#onetrust-consent-sdk #onetrust-pc-sdk .ot-pc-header,',
                '#onetrust-consent-sdk #onetrust-pc-sdk .ot-pc-footer,',
                '#onetrust-consent-sdk #onetrust-pc-sdk #ot-pc-content {',
                '  font-family: "Riforma LL Light", sans-serif !important;',
                '  background-color: #EFEFEF !important;',
                '  color: #1E1E1E !important;',
                '}',

                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-policy-text,',
                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-policy-title,',
                '#onetrust-consent-sdk #onetrust-pc-sdk #ot-pc-title,',
                '#onetrust-consent-sdk #onetrust-pc-sdk #ot-pc-desc,',
                '#onetrust-consent-sdk #onetrust-pc-sdk #ot-category-title,',
                '#onetrust-consent-sdk #onetrust-pc-sdk #ot-lst-title p,',
                '#onetrust-consent-sdk #onetrust-pc-sdk .ot-cat-header,',
                '#onetrust-consent-sdk #onetrust-pc-sdk .ot-acc-grpdesc,',
                '#onetrust-consent-sdk #onetrust-pc-sdk .ot-always-active {',
                '  font-family: "Riforma LL Light", sans-serif !important;',
                '  color: #1E1E1E !important;',
                '  text-transform: none !important;',
                '}',

                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-accept-btn-handler,',
                '#onetrust-consent-sdk #onetrust-pc-sdk #accept-recommended-btn-handler,',
                '#onetrust-consent-sdk #onetrust-pc-sdk .save-preference-btn-handler {',
                '  font-family: "GT America Mono", monospace !important;',
                '  font-weight: 400 !important;',
                '  background-color: #1E1E1E !important;',
                '  color: #ffffff !important;',
                '  border: 1px solid #1E1E1E !important;',
                '  border-radius: 4px !important;',
                '  padding: 0.75rem 1.5rem !important;',
                '  font-size: 0.875rem !important;',
                '  line-height: 1 !important;',
                '  min-height: 0 !important;',
                '  height: auto !important;',
                '  box-sizing: border-box !important;',
                '  text-transform: uppercase !important;',
                '  letter-spacing: normal !important;',
                '  opacity: 1 !important;',
                '  transition: all 0.2s !important;',
                '  overflow: hidden !important;',
                '  position: relative !important;',
                '}',

                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-accept-btn-handler:hover,',
                '#onetrust-consent-sdk #onetrust-pc-sdk #accept-recommended-btn-handler:hover,',
                '#onetrust-consent-sdk #onetrust-pc-sdk .save-preference-btn-handler:hover,',
                '#onetrust-consent-sdk #onetrust-pc-sdk .ot-pc-refuse-all-handler:hover,',
                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-reject-all-handler:hover,',
                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-pc-btn-handler:hover {',
                '  background-color: #B277FD !important;',
                '  border-color: #B277FD !important;',
                '  color: #1E1E1E !important;',
                '  text-decoration: none !important;',
                '}',

                '#onetrust-consent-sdk #onetrust-pc-sdk .ot-pc-refuse-all-handler,',
                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-reject-all-handler,',
                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-pc-btn-handler {',
                '  font-family: "GT America Mono", monospace !important;',
                '  font-weight: 400 !important;',
                '  background-color: transparent !important;',
                '  color: #1E1E1E !important;',
                '  border: 1px solid #1E1E1E !important;',
                '  border-radius: 4px !important;',
                '  padding: 0.75rem 1.5rem !important;',
                '  font-size: 0.875rem !important;',
                '  line-height: 1 !important;',
                '  min-height: 0 !important;',
                '  height: auto !important;',
                '  box-sizing: border-box !important;',
                '  text-transform: uppercase !important;',
                '  letter-spacing: normal !important;',
                '  text-decoration: none !important;',
                '  opacity: 1 !important;',
                '  transition: all 0.2s !important;',
                '  overflow: hidden !important;',
                '  position: relative !important;',
                '}',

                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-pc-btn-handler,',
                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-reject-all-handler,',
                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-accept-btn-handler {',
                '  display: inline-flex !important;',
                '  align-items: center !important;',
                '  justify-content: center !important;',
                '  width: auto !important;',
                '  max-width: none !important;',
                '  min-width: 0 !important;',
                '  flex: 0 0 auto !important;',
                '  align-self: center !important;',
                '  margin-left: 0 !important;',
                '  margin-right: 0 !important;',
                '}',

                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group {',
                '  display: flex !important;',
                '  align-items: center !important;',
                '  justify-content: flex-end !important;',
                '  flex-wrap: wrap !important;',
                '  gap: 12px !important;',
                '  width: 100% !important;',
                '  max-width: none !important;',
                '}',

                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-pc-btn-handler {',
                '  margin-right: auto !important;',
                '}',

                '#onetrust-consent-sdk #onetrust-banner-sdk .banner-actions-container {',
                '  display: flex !important;',
                '  align-items: center !important;',
                '  justify-content: flex-end !important;',
                '  gap: 12px !important;',
                '  width: auto !important;',
                '  max-width: none !important;',
                '}',

                '@media only screen and (max-width: 1023px) {',
                '  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group {',
                '    justify-content: center !important;',
                '  }',
                '  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-pc-btn-handler,',
                '  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-reject-all-handler,',
                '  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-accept-btn-handler {',
                '    margin-right: 0 !important;',
                '    margin-left: 0 !important;',
                '    width: 100% !important;',
                '    flex: 0 0 100% !important;',
                '    justify-content: center !important;',
                '    padding: 0.75rem 1.5rem !important;',
                '    box-sizing: border-box !important;',
                '  }',
                '  #onetrust-consent-sdk #onetrust-banner-sdk .banner-actions-container {',
                '    justify-content: center !important;',
                '    width: 100% !important;',
                '    flex-direction: column !important;',
                '  }',
                '}',

                '#onetrust-consent-sdk #onetrust-pc-sdk .ot-pc-footer {',
                '  border-top: 1px solid #DEDEDE !important;',
                '}',

                '#onetrust-consent-sdk #onetrust-banner-sdk .ot-sdk-container,',
                '#onetrust-consent-sdk #onetrust-banner-sdk .ot-sdk-row,',
                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group-parent,',
                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group,',
                '#onetrust-consent-sdk #onetrust-pc-sdk .ot-pc-footer,',
                '#onetrust-consent-sdk #onetrust-pc-sdk .ot-pc-footer-logo,',
                '#onetrust-consent-sdk #onetrust-pc-sdk .ot-btn-container {',
                '  overflow: visible !important;',
                '}',

                '#onetrust-consent-sdk .ot-otto-content {',
                '  display: inline-flex !important;',
                '  align-items: center;',
                '  gap: 8px;',
                '  pointer-events: none;',
                '  position: relative;',
                '}',
                '#onetrust-consent-sdk .ot-otto-content svg {',
                '  height: 14px !important;',
                '  width: 14px !important;',
                '  min-height: 14px !important;',
                '  min-width: 14px !important;',
                '  display: block !important;',
                '}',
                '#onetrust-consent-sdk .ot-otto-icon {',
                '  display: flex !important;',
                '  align-items: center;',
                '  justify-content: center;',
                '  color: #ffffff;',
                '  width: 14px !important;',
                '  height: 14px !important;',
                '  min-width: 14px !important;',
                '  min-height: 14px !important;',
                '  flex-shrink: 0 !important;',
                '  margin: 0 !important;',
                '  padding: 0 !important;',
                '}',
                '#onetrust-consent-sdk .ot-otto-icon-left {',
                '  transition: 0.3s var(--cubic-easing) opacity, 0.3s var(--cubic-easing) transform;',
                '  opacity: 0;',
                '  position: absolute !important;',
                '  left: -22px;',
                '  top: 50%;',
                '  overflow: visible !important;',
                '  transform: translate3d(-30px, -50%, 0);',
                '}',
                '#onetrust-consent-sdk .ot-otto-content,',
                '#onetrust-consent-sdk .ot-otto-content * {',
                '  font-weight: 400 !important;',
                '  font-family: "GT America Mono", monospace !important;',
                '  font-size: inherit !important;',
                '  line-height: 1 !important;',
                '}',
                '#onetrust-consent-sdk .ot-otto-text {',
                '  white-space: nowrap;',
                '  text-transform: uppercase !important;',
                '  transition: 0.3s var(--cubic-easing) transform;',
                '  transform: translate3d(0, 0, 0);',
                '}',
                '#onetrust-consent-sdk .ot-otto-icon-right {',
                '  transition: 0.3s var(--cubic-easing) opacity, 0.3s var(--cubic-easing) transform;',
                '  opacity: 1;',
                '  transform: translate3d(0, 0, 0);',
                '  overflow: visible !important;',
                '}',
                '#onetrust-consent-sdk #onetrust-pc-sdk .ot-pc-refuse-all-handler .ot-otto-icon,',
                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-reject-all-handler .ot-otto-icon,',
                '#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-pc-btn-handler .ot-otto-icon {',
                '  color: #1E1E1E !important;',
                '}',
                '@media (hover: hover) and (pointer: fine) {',
                '  #onetrust-consent-sdk button:hover .ot-otto-icon {',
                '    color: #1E1E1E !important;',
                '  }',
                '  #onetrust-consent-sdk button:hover .ot-otto-icon-left {',
                '    opacity: 1 !important;',
                '    transform: translate3d(11px, -50%, 0) !important;',
                '  }',
                '  #onetrust-consent-sdk button:hover .ot-otto-text {',
                '    transition: 0.35s var(--cubic-easing) transform !important;',
                '    transition-delay: 0.05s !important;',
                '    transform: translate3d(11px, 0, 0) !important;',
                '  }',
                '  #onetrust-consent-sdk button:hover .ot-otto-icon-right {',
                '    opacity: 0 !important;',
                '    transform: translate3d(30px, 0, 0) !important;',
                '  }',
                '}',
              ].join('\\n');
              document.head.appendChild(s);
            }

            var arrowSvg = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.529 2.862c.26-.26.682-.26.942 0l4.667 4.667c.26.26.26.682 0 .942l-4.667 4.667a.667.667 0 0 1-.942-.943l3.528-3.528H3.333a.667.667 0 0 1 0-1.334h7.724L7.53 3.805a.667.667 0 0 1 0-.943Z" fill="currentColor"></path></svg>';
            var btns = document.querySelectorAll('#onetrust-accept-btn-handler, #accept-recommended-btn-handler, .save-preference-btn-handler, .ot-pc-refuse-all-handler, #onetrust-reject-all-handler, #onetrust-pc-btn-handler');
            btns.forEach(function(btn) {
              if (btn.querySelector('.ot-otto-content')) return;
              var text = btn.textContent;
              btn.textContent = '';
              var wrap = document.createElement('div');
              wrap.className = 'ot-otto-content';
              var left = document.createElement('figure');
              left.className = 'ot-otto-icon ot-otto-icon-left';
              left.innerHTML = arrowSvg;
              var span = document.createElement('span');
              span.className = 'ot-otto-text';
              span.textContent = text;
              var right = document.createElement('figure');
              right.className = 'ot-otto-icon ot-otto-icon-right';
              right.innerHTML = arrowSvg;
              wrap.appendChild(left);
              wrap.appendChild(span);
              wrap.appendChild(right);
              btn.appendChild(wrap);
            });

            window.dispatchEvent(new CustomEvent("OneTrustConsentUpdated"));
          }
        `}
      </Script>

      {/* ACCESSIBE */}

      <Script key="AccessiBe">
        {`
          (function(){
            var s    = document.createElement('script');
            var h    = document.querySelector('head') || document.body;
            s.src    = 'https://acsbapp.com/apps/app/dist/js/app.js';
            s.async  = true;
            s.onload = function(){
                acsbJS.init({
                    statementLink    : '',
                    footerHtml       : '',
                    hideMobile       : false,
                    hideTrigger      : false,
                    disableBgProcess : false,
                    language         : 'en',
                    position         : 'left',
                    leadColor        : '#1e1e1e',
                    triggerColor     : '#1e1e1e',
                    triggerRadius    : '50%',
                    triggerPositionX : 'left',
                    triggerPositionY : 'bottom',
                    triggerIcon      : 'people',
                    triggerSize      : 'medium',
                    triggerOffsetX   : 20,
                    triggerOffsetY   : 20,
                    mobile           : {
                        triggerSize      : 'small',
                        triggerPositionX : 'left',
                        triggerPositionY : 'bottom',
                        triggerOffsetX   : 10,
                        triggerOffsetY   : 10,
                        triggerRadius    : '50%'
                    }
                });
            };
            h.appendChild(s);
          })();
        `}
      </Script>
    </>
  )
}

export default Scripts;
